module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-painless-time-tracking-733cc80207c6d541456eb23b8a892fb0.png";